module.exports = __webpack_public_path__ + "static/media/layers.b154d1e1.png";